export default __webpack_public_path__ + "static/insight-light-20cbc9261eab50567fa5f1b827a4d97c.png";